import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchJustificationReverseLogisticsActions as Actions,
  FetchJustificationReverseLogisticsRequestAction as RequestAction,
} from 'store/ducks/justificationsReverseLogistics';

export function* fetchJustificationReverseLogisticsRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, `reverse-logistics/configurations/justifications/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
